// Restores the popstate semantics our tab UIs were built on, which Turbo 8.0.21 changed.
//
// Turbo now acts on every history pop. An entry with no `turbo` state is adopted
// (historyPoppedWithEmptyState): Turbo overwrites the entry's state with its own and snapshots
// the live page, firing turbo:before-cache — which unmounts every React component — with no
// render to follow, and turning the next pop onto that entry into a full restoration visit. And
// a pop whose URL differs from the rendered page only in the fragment is a full restoration
// visit outright (8.0.21 also removed the same-page-anchor short-circuit). Turbo <= 8.0.20
// ignored the first case and short-circuited the second, and our tab controllers were built on
// that: Galette's tablist owns path-per-tab entries, and the profile tabs own fragment-per-tab
// entries (helpers/location_hash). See docs/turbo_2.0.23_update.md.
//
// Listeners on the same target run in registration order, so this module can only stop Turbo's
// popstate listener if it registers first: import it before anything that evaluates Turbo.
//
// Pops this guard swallows are re-dispatched as `history:popstate` (state in event.detail) for
// code that manages its own history entries — raw popstate never reaches listeners registered
// after Turbo for these.

let renderedUrl = window.location.href

const stripHash = href => href.split('#')[0]

window.addEventListener('popstate', event => {
  const popped = window.location.href

  if (window.Turbo) {
    const turboOwned = Boolean(event.state?.turbo)
    const hashOnlyChange = stripHash(popped) === stripHash(renderedUrl)

    if (!turboOwned || hashOnlyChange) {
      event.stopImmediatePropagation()
      window.dispatchEvent(new CustomEvent('history:popstate', { detail: { state: event.state } }))
    }
  }

  renderedUrl = popped
})

document.addEventListener('turbo:load', () => {
  renderedUrl = window.location.href
})
